import { ViewportTrackerService } from '$js/isolated/ViewportTrackerService';

export class MarqueeFooterPartners {
  private marqueeElement: Element | null = document.querySelector('.js-marquee-footer-partners');
  private firstItemOfMarqueElement: HTMLElement | null = document.querySelector('.js-marquee-footer-partners > *:first-child');
  private eventNames = ['marqueePartnersIn', 'marqueePartnersOut'];
  private interval: ReturnType<typeof setInterval> | undefined = undefined;
  private marginLeft = 0;
  private cloneCount = 0;

  constructor() {
    this.init();
  }

  init() {
    if (!this.marqueeElement) {
      return;
    }

    this.multiplyUntilLargerThanViewportWidth();

    window.addEventListener('debouncedResize', () => {
      this.multiplyUntilLargerThanViewportWidth();
    });

    const watchElement = new ViewportTrackerService({
      eventNameIn: this.eventNames[0],
      eventNameOut: this.eventNames[1],
    });

    watchElement.track(this.marqueeElement);

    document.addEventListener(this.eventNames[0], () => {
      this.startMarquee();
    });

    document.addEventListener(this.eventNames[1], () => {
      this.stopMarquee();
    });

    this.marqueeElement.addEventListener('mouseenter', () => {
      this.stopMarquee();
    });

    this.marqueeElement.addEventListener('mouseleave', () => {
      this.startMarquee();
    });
  }

  private multiplyUntilLargerThanViewportWidth() {
    if (!this.marqueeElement || !this.firstItemOfMarqueElement) {
      return;
    }

    if (this.cloneCount > 8) {
      return;
    }

    if (this.marqueeElement.clientWidth <= (window.innerWidth + this.firstItemOfMarqueElement.clientWidth)) {
      const element = this.firstItemOfMarqueElement.cloneNode(true) as HTMLElement;
      element.removeAttribute('style');

      this.marqueeElement.appendChild(element);
      this.cloneCount += 1;

      this.multiplyUntilLargerThanViewportWidth();
    }
  }

  private startMarquee() {
    if (!this.marqueeElement) {
      return;
    }

    this.interval = setInterval(() => {
      if (!this.firstItemOfMarqueElement) {
        return;
      }

      this.firstItemOfMarqueElement.style.marginLeft = `-${Math.round(this.marginLeft).toString()}px`;
      if (this.marginLeft > this.firstItemOfMarqueElement.clientWidth) {
        this.marginLeft = 0;
      }

      this.marginLeft = this.marginLeft + 0.3;
    }, 5);
  }

  private stopMarquee() {
    if (!this.marqueeElement) {
      return;
    }

    clearInterval(this.interval);
  }
}
